import styled from '@emotion/styled/macro'
import { Button, IconButton, Select } from '@material-ui/core'
import { BRAND_COLOR } from 'lib/constants'

export const COLUMN_GAP = 18

export const LANGUAGE_COL_WIDTH = 280
export const RIGHT_COL_WIDTH = 230

export const COLOR_SELECT_WIDTH = 76

export const Section = styled.div({
  background: '#fff',
  border: '1px solid rgba(0,0,0,0.08)',
  borderRadius: 12,
  overflow: 'hidden',
})

export const Body = styled.div({
  padding: 16,
})

export const EveryoneRow = styled.div({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: 16,
  marginBottom: 16,

  '@media (min-width: 950px)': {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 18,
  },

  '@media (min-width: 1800px)': {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: 18,
  },
})

export const EveryoneBanner = styled.div({
  border: '1px solid rgba(0,0,0,0.08)',
  borderRadius: 12,
  background: 'rgba(0,0,0,0.02)',
  padding: '14px 16px',
  width: '100%',
  boxSizing: 'border-box',
})

export const EveryoneTitle = styled.div({
  fontFamily: 'Montserrat',
  fontWeight: 900,
  fontSize: 20,
  marginBottom: 4,
  color: 'rgba(0,0,0,0.9)',
})

export const EveryoneMeta = styled.div({
  fontSize: 14,
  fontWeight: 600,
  color: 'rgba(0,0,0,0.55)',
})

export const CardsGrid = styled.div({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: 16,

  '@media (min-width: 950px)': {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 18,
  },

  '@media (min-width: 1800px)': {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: 18,
  },
})

export const ChannelCard = styled.div<{ receiving?: boolean }>(({ receiving }) => ({
  border: receiving ? `1px solid ${BRAND_COLOR}` : '1px solid rgba(0,0,0,0.08)',
  borderRadius: 12,
  overflow: 'hidden',
  background: receiving ? 'rgba(0,0,0,0.01)' : '#fff',
  boxShadow: receiving ? `0 0 0 2px rgba(0,0,0,0.02)` : '0 1px 0 rgba(0,0,0,0.03)',
  transition: 'background 140ms ease, border-color 140ms ease, box-shadow 140ms ease',
}))

export const ChannelCardHeader = styled.div<{ receiving?: boolean }>(({ receiving }) => ({
  padding: '12px 14px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: receiving ? 'rgba(0,0,0,0.05)' : 'rgba(0,0,0,0.02)',
  borderBottom: '1px solid rgba(0,0,0,0.06)',
  transition: 'background 140ms ease',

  '&:hover .channel-delete': {
    opacity: 1,
    pointerEvents: 'auto',
  },
}))

export const ChannelNameWrap = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  minWidth: 0,
})

export const ChannelRxIcon = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: BRAND_COLOR,
  flex: '0 0 auto',
})

export const ChannelName = styled.div<{ receiving?: boolean }>(({ receiving }) => ({
  fontFamily: 'Montserrat',
  fontWeight: 900,
  fontSize: 20,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: receiving ? BRAND_COLOR : 'inherit',
  transition: 'color 140ms ease',
}))

export const ChannelDeleteButton = styled(IconButton)({
  opacity: 0,
  pointerEvents: 'none',
  transition: 'opacity 140ms ease',
  padding: 4,
  color: 'rgba(0,0,0,0.55)',

  '&:hover': {
    color: BRAND_COLOR,
  },
})

export const Rows = styled.div({
  display: 'flex',
  flexDirection: 'column',
})

export const EmptyRow = styled.div({
  padding: '16px 14px',
  color: 'rgba(0,0,0,0.55)',
  fontFamily: 'Montserrat',
  fontWeight: 700,
})

export const Left = styled.div({
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
})

export const NameWrap = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  minWidth: 0,
  width: '100%',
})

export const Name = styled.div({
  minWidth: 0,
  overflow: 'visible',
  textOverflow: 'clip',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  overflowWrap: 'anywhere',
  lineHeight: 1.25,
  fontWeight: 800,
  fontSize: 15,
  letterSpacing: '-0.2px',
})

export const RowDeleteButton = styled(IconButton)({
  opacity: 0,
  pointerEvents: 'none',
  transition: 'opacity 140ms ease',
  padding: 4,
  color: 'rgba(0,0,0,0.55)',
  flex: '0 0 auto',

  '&:hover': {
    color: BRAND_COLOR,
  },
})

export const ColorCol = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 0,
})

export const Mid = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 12,
  minWidth: 0,
  flexWrap: 'nowrap',
})

export const Row = styled.div({
  display: 'grid',
  gridTemplateColumns: `minmax(0, 1fr) ${COLOR_SELECT_WIDTH}px auto`,
  alignItems: 'center',
  columnGap: COLUMN_GAP,
  padding: '14px 14px',
  borderBottom: '1px solid rgba(0,0,0,0.06)',
  ':last-of-type': { borderBottom: 'none' },

  '@media (max-width: 560px)': {
    gridTemplateColumns: `minmax(0, 1fr) ${COLOR_SELECT_WIDTH}px auto`,
    columnGap: 12,
  },

  '&:hover .row-delete': {
    opacity: 1,
    pointerEvents: 'auto',
  },
})

export const Meta = styled.div({
  fontSize: 11,
  color: 'rgba(0,0,0,0.55)',
  whiteSpace: 'nowrap',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flex: '0 0 auto',
})

export const ViewButton = styled(Button)({
  borderRadius: 18,
  height: 34,
  paddingLeft: 14,
  paddingRight: 14,
  fontWeight: 800,
  textTransform: 'none',
  minWidth: 74,
  flex: '0 0 auto',
})

export const LanguageSelect = styled(Select)({
  boxSizing: 'border-box',
  // Fill the column (minus the reserved delete slot) up to 200px, so every
  // row's pill is the same width. Long labels ellipsize rather than widen it.
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 0,
  minWidth: 0,
  maxWidth: 200,

  background: 'rgba(0,0,0,0.04)',
  borderRadius: 18,
  height: 34,
  border: '1px solid rgba(0,0,0,0.12)',
  paddingLeft: 8,
  paddingRight: 8,
  fontWeight: 800,

  '.MuiSelect-select': {
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 10,
    paddingRight: 28,
    // Keep the pill a fixed size; ellipsize long language labels.
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '.MuiSelect-icon': { right: 8 },
})

export const ColorSelect = styled(Select)({
  boxSizing: 'border-box',
  width: COLOR_SELECT_WIDTH,
  minWidth: COLOR_SELECT_WIDTH,
  maxWidth: COLOR_SELECT_WIDTH,

  background: 'rgba(0,0,0,0.04)',
  borderRadius: 18,
  height: 34,
  border: '1px solid rgba(0,0,0,0.12)',
  paddingLeft: 8,
  paddingRight: 8,

  '.MuiSelect-select': {
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    paddingRight: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '.MuiSelect-icon': { right: 8 },
})

export const SwatchBox = styled.div({
  width: 16,
  height: 16,
  borderRadius: 5,
  border: '1px solid rgba(0,0,0,0.15)',
  flex: '0 0 auto',
})